import { TRANSLATION_CONSTANTS } from "../../app-consts/translations";
import { determineLocale } from "../../contexts/LocaleContext";

export interface ComplianceUrls {
  accessibility: string;
  notice_at_collection?: string;
  privacy: string;
  terms_and_condition?: string;
  sms_terms_condition?: string;
}

type SupportedLocale = 'en_us' | 'en_ca' | 'fr_ca';

export const getComplianceUrls = (isAllstateCanadaCompliance: boolean): ComplianceUrls => {
  const locale : string = determineLocale();
  const urls: Record<SupportedLocale, ComplianceUrls> = {
    en_us: {
      accessibility: "https://www.allstate.com/accessibility",
      notice_at_collection: "https://roadsidemobile.com/tac/privacystatement#info-we-collect",
      privacy: "https://www.roadsidemobile.com/privacy",
      terms_and_condition: "https://roadsidemobile.com/tac/ppu",
      sms_terms_condition: TRANSLATION_CONSTANTS.SMS_TERMS_CONDITION_LINK
    },
    en_ca: isAllstateCanadaCompliance
      ? {
          accessibility: "https://www.allstate.ca/customercare/accessibility-standards",
          privacy: "https://www.allstate.ca/customercare/privacy-security",
        }
      : {
          accessibility: "https://www.allstate.com/accessibility",
          privacy: "https://www.roadsidemobile.com/tac/privacystatement",
        },
    fr_ca: isAllstateCanadaCompliance 
      ? {
        accessibility: "https://www.allstate.ca/fr-ca/customercare/accessibility-standards",
        privacy: "https://www.allstate.ca/fr-ca/customercare/privacy-security",
      }
      : {
        accessibility: "https://roadsidemobile.com/tac/frenchaccessibility",
        privacy: "https://www.roadsidemobile.com/tac/frenchprivacystatement",
      }
  };

  return urls[locale?.toLowerCase() as SupportedLocale] || urls.en_us;
};
